import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=040b8733&"
import script from "./Panels.vue?vue&type=script&lang=js&"
export * from "./Panels.vue?vue&type=script&lang=js&"
import style0 from "./Panels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports